<div class="card">
    <div class="card-body">
        <div class="row mb-3">
            @for (item of documents(); track $index) {
                <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                    <div class="card">
                        <div class="card-body position-relative text-center">
                            <img src="assets/Images/pdf-icon.png" alt="Pdf icon" class="img-fluid mb-2" />

                            @if (loading().isLoading && loading().id == item.resumeRequiredDocumentId) {
                                <div class="loading-overlay">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Cargando...</span>
                                    </div>
                                    <p class="mt-2 loading-text">Guardando documento...</p>
                                </div>
                            }

                            <p class="mb-1">{{ item?.documentName }}</p>
                            <!-- Mostrar botones si hay archivo cargado -->
                            @if (item.file || item.fileId) {
                                <div class="d-flex gap-2 justify-content-center mt-2">
                                    <button type="button" class="btn btn-outline-primary btn-sm action-btn" 
                                            (click)="viewFile(item)"
                                            data-bs-toggle="modal"
                                            data-bs-target="#modalDocumento">
                                        <i class="fa-solid fa-eye me-1"></i> Ver
                                    </button>
                                    <button type="button" class="btn btn-outline-danger btn-sm action-btn" 
                                            (click)="deleteFile(item)">
                                        <i class="fa-solid fa-trash me-1"></i> Eliminar
                                    </button>
                                </div>
                            }

                            @if (!item.file && !item.fileId) {
                                <div>
                                    <button type="button" class="btn btn-primary btn-upload-doc" (click)="fileInput.click()">
                                        Subir documento
                                    </button>
                                    <input #fileInput type="file" accept="application/pdf" style="display: none;" (change)="onFileSelected($event, item.resumeRequiredDocumentId)" />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>


<div class="modal fade" id="modalDocumento" tabindex="-1" aria-labelledby="modalDocumentoLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalDocumentoLabel">
                    Documento
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="ratio ratio-4x3">
                    <iframe id="docPrintDocumento"></iframe>
                </div>
            </div>
        </div>
    </div>
</div>